import { CalendarUnit } from '@opengov/reporting-types';

export const CALENDAR_UNIT_LABELS: Record<CalendarUnit, string> = {
  [CalendarUnit.Day]: 'Days',
  [CalendarUnit.FiscalPeriod]: 'Fiscal Periods',
  [CalendarUnit.FiscalQuarter]: 'Fiscal Quarters',
  [CalendarUnit.FiscalYear]: 'Fiscal Years',
  [CalendarUnit.Month]: 'Months',
  [CalendarUnit.Quarter]: 'Calendar Quarters',
  [CalendarUnit.Week]: 'Weeks',
  [CalendarUnit.Year]: 'Calendar Years'
};

export enum CalendarUnitCombo {
  CalendarYearOnly,
  FiscalYearOnly,
  FiscalYearAndPeriod,
  FullDate
}

export const COMBOS_OF_CALENDAR_UNITS = {
  [CalendarUnitCombo.CalendarYearOnly]: [CalendarUnit.Year],
  [CalendarUnitCombo.FiscalYearOnly]: [CalendarUnit.FiscalYear],
  [CalendarUnitCombo.FiscalYearAndPeriod]: [
    CalendarUnit.Year,
    CalendarUnit.FiscalYear,
    CalendarUnit.Quarter,
    CalendarUnit.FiscalQuarter,
    CalendarUnit.Month,
    CalendarUnit.FiscalPeriod
  ],
  [CalendarUnitCombo.FullDate]: [
    CalendarUnit.Year,
    CalendarUnit.FiscalYear,
    CalendarUnit.Quarter,
    CalendarUnit.FiscalQuarter,
    CalendarUnit.Month,
    CalendarUnit.Week,
    CalendarUnit.Day
  ]
};
